export const isFirestoreAlreadyExistsError = (
  error: unknown,
): error is { code: string } => {
  if (typeof error !== 'object' || error === null) {
    return false;
  }
  if (!('code' in error)) {
    return false;
  }
  const code = (error as { code?: unknown }).code;
  return typeof code === 'string' && code.includes('already-exists');
};
